import React from 'react'
import {get,range} from 'lodash-es';
import styled from 'styled-components';
import Tabela, {TabelaLinha as TL} from '../../Common/Tabela';
import CelulaHeader from '../../Common/CelulaHeader';
import Celula from '../../Common/Celula';
import MIAdmissoes from '../MoreInfo/Admissoes';
import MIRescisoes from '../MoreInfo/Rescisoes';
import MIFerias from '../MoreInfo/Ferias';
import MIAfast from '../MoreInfo/Afast';
import MIEmprFolha from '../MoreInfo/EmprFolha';
import MIIRRF from '../MoreInfo/IRRF';
import MIInssEmpregado from '../MoreInfo/InssEmpregado';
import MISalMat from '../MoreInfo/SalMat';
import MyDialog from '../MoreInfo/MyDialog';
import GrAdmissoesRescisoes from '../Graficos/AdmissoesRescisoes';
import Button from '@material-ui/core/Button';
import BarChartIcon from '@material-ui/icons/BarChart';
import useFetchData from '../../crud/useFetchData';
import {proto,url} from '../../Helpers/api';
import MostraEncargo from './MostraEncargo';
import {formataMoeda} from '../../Helpers/money';
import {mesesExtenso3} from '../../Helpers/date';
import GraficoAno from '../MoreInfo/GraficoAno';

const TabelaLinha = styled(TL)`
  grid-template-columns: 80px repeat(12,80px) 40px;
`

const ShowMetrica = ({Dialog, ...props}) => {
  let Container = Dialog ? Dialog : React.Fragment
  return (
    <Container>
      <ShowMetrica_ {...props}/>
    </Container>
  )
}
const ShowMetrica_ = props => {
  const { ano, empresa, data, attrKey, attr, modif=v=>v, modalData, modalSetData } = props;
  return (
    <TabelaLinha boldFirst>
      <Celula>{attr}</Celula>
      {range(1,13).map(mes => {
        let value = get(data, `${ano}.${mes}.${attrKey}`, "-")
        let onC = modalSetData && value && (value !== "-")
        return (
          <Celula
            align="flex-end"
            key={"b"+mes}
            onClick={onC ? (()=>modalSetData({ano,mes,empresa})) : undefined}
          >
          {modif(value)}
          </Celula>
        )
      })}
      <Celula
        align="flex-end"
        key={"g"}
        onClick={modalSetData ? (
          () => modalSetData({ ...props, graph: true })
        ) : undefined}
      >
        <BarChartIcon />
      </Celula>

    </TabelaLinha>
  )
}



function DetalhesMetricas (props) {
  const { data, empresa, ano, attrKey, attr } = props;
  // if (!data.filter(o=>get(o[attrKey]).length) return null;
  return (
    <ShowMetrica
      {...props}
      data={data}
      empresa={empresa}
      ano={ano} attrKey={"totais." + attrKey} attr={attr} modif={formataMoeda}
      Dialog={MyDialog(DetalhesModal(props))}
    />
  )
}

// Nesta função, as props referentes a celula que o usuário clicou são embutidas
// no objeto 'dados'
function AbreDetalhesModal (props) {
  let { dados={}, data={}, ModalDataComponent } = props;
  const { mes, ano, graph } = dados;
  if (graph) return <GraficoAno {...props} />;
  const fData = get(data, `${ano}.${mes}`);
  ModalDataComponent = ModalDataComponent || MostraEncargo
  return (
    <ModalDataComponent
      {...props}
      data={fData}
    />
  )
}

function DetalhesModal (props) {
  const { data, attr, attrKey, ModalDataComponent } = props;
  return (_props) => (
    <AbreDetalhesModal {..._props}
      data={data} 
      attr={attr} 
      attrKey={attrKey} 
      ModalDataComponent={ModalDataComponent}
    />
  )
}

// attrKey, attr
let encargosList = [
  [ "Remuneracoes", "Remunerações" ],
  [ "ValorFgts", "FGTS" ],
  [ "FgtsGrrf", "FGTS (GRRF)" ],
  // [ "InssEmpresaTotal", "INSS Empresa" ], //removido a pedido do Thiago
  // [ "InssEmpresa", "INSS Empresa" ],
  // [ "InssTerceiro", "INSS Terceiro" ],
  // [ "RAT", "RAT" ],
  // [ "Deducoes", "Deduções" ],
  // [ "ValorInss", "INSS Empregado", MIInssEmpregado  ], // criar modal
  // EncargosInss
  // [ "ValorInss", "Inss Encargos" ], //removido a pedido do Thiago
  // [ "DedInssMat13", "Inss DedSalMat13" ], //removido a pedido do Thiago
  // [ "Deducoes", "Inss Deduções" ], //removido a pedido do Thiago
  //
  // [ "ValorSalMatCalc", "Sal Maternidade", MISalMat ], //removido a pedido do Thiago
  //
  // [ "ValorTotalARecolher", "Guia INSS (TOTAL)" ], //removido a pedido do Thiago
  // [ "ValorSegurados", "Guia INSS (segurados)" ], //removido a pedido do Thiago
  // [ "ValorOutrasEntidades", "Guia INSS (outros)" ], //removido a pedido do Thiago
  // [ "ValorTotalEmpresa", "Guia INSS (empresa)" ], //removido a pedido do Thiago
  // [ "ValorTotalCompensacao", "Guia INSS (deduções)" ], //removido a pedido do Thiago
  // [ "ValorPis", "PIS" ], //removido a pedido do Thiago
  [ "ValorIrrf", "IRRF", MIIRRF ],
  // [ "TOTAL", "Total" ],
]

function Detalhes (props) {
  const { ano, empresa } = props;
  const f1 = useFetchData(`${proto}://${url}/main/encargos-folha/${empresa}/${ano}`);
  // const f2 = useFetchData(`${proto}://${url}/main/encargos-folha-13/${empresa}/${ano}`);
  // const f2 = useFetchData(`${proto}://${url}/main/irrf-mensal/${empresa}/${ano}`);
  if (f1.isLoading) return <div>Carregando...</div>;
  // if (f1.isLoading || f2.isLoading) return <div>Carregando...</div>;
  if (!f1.data) return null;
  // if (!f1.data || !f2.data) return null;
  return [
    encargosList.map( ([ attrKey, attr, ModalDataComponent ], i) => (
      <DetalhesMetricas {...props} data={f1.data} key={attr + i}
        attrKey={attrKey}
        attr={attr}
        ModalDataComponent={ModalDataComponent}
      />
    )),
    // <DetalhesMetricas {...props} data={f2.data} key={"valorIRRF"}
    //   attrKey={"ValorIRRF"}
    //   attr={"IRRF"}
    //   ModalDataComponent={MIIRRF}
    // />
    // encargosList13.map( ([ attrKey, attr ], i) => (
    //   <DetalhesMetricas {...props} data={f2.data} key={attr + "13o" + i}
    //     attrKey={attrKey}
    //     attr={attr}
    //   />
    // )),
  ]
}

// attrKey, attr, DialogComponent, valueModifier
let metricasList = [
  [ "qtdeAdmissoes", "Admissões", MyDialog(MIAdmissoes), ],
  [ "qtdeRescisoes", "Rescisões", MyDialog(MIRescisoes), ],
  [ "qtdeFerias", "Férias", MyDialog(MIFerias), ],
  [ "qtdeAfastamentos", "Afastamentos", MyDialog(MIAfast), ],
  [ "qtdeEmprFolha", "Empregados em Folha", MyDialog(MIEmprFolha), ],
  [ "folhaLiquido", "Valor Líquido de Folha", , formataMoeda ],
  [ "feriasLiquido", "Valor Líquido de Férias", , formataMoeda ],
  [ "rescLiquido", "Valor Líquido de Rescisões", , formataMoeda ],
]

export default function MetricasUI (props) {
  const { ano, empresa, metricas, loading, verDetalhes, setVerDetalhes } = props;
  const today = new Date();
  const month = today.getMonth(),
        year = today.getFullYear();
  if (!empresa) return null;
  if (loading) return <div>Carregando dados...</div>;
  return (
    <div style={{
      width: "auto",
      marginTop: "15px",
      padding: "10px",
      border: "1px solid #DDD",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }}>
      <Tabela>
        <TabelaLinha header>
          <CelulaHeader field={['m','Métrica']} />
          {mesesExtenso3.map((mes,i) => (
            <CelulaHeader key={"a"+i} field={[mes,mes]} align="flex-end" />
          ))}
          {/* <CelulaHeader key={"az"} field={[".","."]} align="flex-end" /> */}
          <CelulaHeader key={"az"} field={["actions",""]} align="flex-end" />
        </TabelaLinha>
        {metricasList.map(([attrKey, attr, Dialog_, modif]) => (
          <ShowMetrica key={"sm"+attrKey}
            data={metricas} empresa={empresa} ano={ano}
            attrKey={attrKey}
            attr={attr}
            Dialog={Dialog_}
            modif={modif}
          />
        ))}
        <div style={{
          padding: "2px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderTop: "1px solid #bbb",
          borderBottom: "1px solid #bbb",
        }}>
          <div style={{ marginRight: "20px" }}>ENCARGOS</div>
          <Button variant="outlined" onClick={() => setVerDetalhes(!verDetalhes)}>
          {verDetalhes ? "Ocultar..." : "Ver..."}
          </Button>
        </div>
        {verDetalhes && (
          <Detalhes {...props} /> 
        )}
      </Tabela>
      <GrAdmissoesRescisoes
        data={mesesExtenso3.map((mes,i) => ({
          mes,
          admissoes: get(metricas, [ano,i+1,"qtdeAdmissoes"], 0),
          rescisoesF: get(metricas, [ano,i+1,"qtdeRescisoes"], 0),
          empregados: (year >= ano) && (month > i) && (
              get(metricas, [ano,i+1,"qtdeEmprFolha"], 0)
            ) || null,
        }))}
      />
    </div>
  )
}
